// CP Product Slider
function initCpSlider(sliderInner) {
  if (!sliderInner || sliderInner.children.length <= 1) {
    return;
  }

  const configJSON = sliderInner.getAttribute("data-config");
  if (!configJSON) {
    return;
  }

  try {
    const config = JSON.parse(configJSON);

    if (sliderInner.cpFlickityInstance) {
      sliderInner.cpFlickityInstance.destroy();
    }

    sliderInner.cpFlickityInstance = new Flickity(sliderInner, config);
  } catch (error) {
    console.error("CP Slider config error:", error);
  }
}

function destroyCpSlider(sliderInner) {
  if (sliderInner && sliderInner.cpFlickityInstance) {
    sliderInner.cpFlickityInstance.destroy();
    sliderInner.cpFlickityInstance = null;
  }
}

function cpProductSlider(scope = document) {
  const sliders = [];

  if (scope.matches && scope.matches("[data-slider]")) {
    sliders.push(scope);
  }

  if (scope.querySelectorAll) {
    scope.querySelectorAll("[data-slider]").forEach((slider) => sliders.push(slider));
  }

  sliders.forEach((slider) => {
    const sliderInner = slider.querySelector(".cp-product-slider-inner");
    initCpSlider(sliderInner);
  });
}

function observeCpSliderMutations() {
  if (window.cpSliderObserver || !document.body) {
    return;
  }

  window.cpSliderObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) {
          return;
        }

        if (node.matches("[data-slider]") || node.querySelector?.("[data-slider]")) {
          cpProductSlider(node);
        }
      });

      mutation.removedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) {
          return;
        }

        const sliderInners = [];

        if (node.matches(".cp-product-slider-inner")) {
          sliderInners.push(node);
        }

        node.querySelectorAll?.(".cp-product-slider-inner").forEach((inner) => sliderInners.push(inner));

        sliderInners.forEach(destroyCpSlider);
      });
    });
  });

  window.cpSliderObserver.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function () {
  cpProductSlider();
  observeCpSliderMutations();
});

if (typeof Shopify !== "undefined" && Shopify.designMode) {
  ["shopify:section:load", "shopify:block:select", "shopify:block:deselect"].forEach(
    (eventName) => {
      document.addEventListener(eventName, function (event) {
        cpProductSlider(event.target);
        observeCpSliderMutations();
      });
    }
  );

  document.addEventListener("shopify:section:unload", function (event) {
    event.target
      .querySelectorAll(".cp-product-slider-inner")
      .forEach(destroyCpSlider);
  });
}
// END CP Product Slider